/** Portal-facing action hints for contract statuses. */
export function contractStatusHint(status) {
    const normalized = status.trim().toUpperCase();
    switch (normalized) {
        case "NIGO":
            return "Action needed — review missing information with your upline or support.";
        case "PENDING":
            return "Your contract is being processed. We'll update this when the carrier responds.";
        case "REJECTED":
            return "This contract was declined or withdrawn. Contact support if you have questions.";
        default:
            return undefined;
    }
}
